import logger from './logger';

export function getErrorMessage(error: any): string {
  logger.debug('errorHandler', 'Extracting error message', { 
    hasResponse: !!error.response,
    hasMessage: !!error.message,
    status: error.response?.status 
  });

  let errorMessage = 'An unknown error occurred';
  
  if (error.response?.data?.detail) {
    if (typeof error.response.data.detail === 'string') {
      errorMessage = error.response.data.detail;
      logger.debug('errorHandler', 'Error message extracted from response detail (string)', { errorMessage });
    } else if (Array.isArray(error.response.data.detail)) {
      errorMessage = error.response.data.detail.map((item: any) => {
        if (typeof item === 'string') return item;
        if (item.msg) return item.msg;
        return JSON.stringify(item);
      }).join(', ');
      logger.debug('errorHandler', 'Error message extracted from response detail (array)', { errorMessage, itemCount: error.response.data.detail.length });
    } else {
      errorMessage = JSON.stringify(error.response.data.detail);
      logger.debug('errorHandler', 'Error message extracted from response detail (object)', { errorMessage });
    }
  } else if (error.message) {
    errorMessage = error.message;
    logger.debug('errorHandler', 'Error message extracted from error.message', { errorMessage });
  } else {
    logger.warn('errorHandler', 'No error message found, using default', { error });
  }
  
  return errorMessage;
}
